/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { SocialIconProps } from '../../types';
import { BadgeContainer } from './badgeContainer';

export const PinterestIcon = memo(({ 
    width = 60, 
    height = 60,
    fillColor = '#ffffff',
    backgroundColor = '#2F6F8C'
}: SocialIconProps) => {
    return (
        <BadgeContainer backgroundColor={backgroundColor} >
            <svg width={width} height={height} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path 
                    d='M20 0.80014C9.3962 0.80014 0.800049 9.39629 0.800049 20.0001C0.800049 28.1341 5.86082 35.0876 13.003 37.8852C12.8353 36.3661 12.6835 34.0298 13.0696 32.3714C13.4185 30.873 15.321 22.8278 15.321 22.8278C15.321 22.8278 14.7467 21.6776 14.7467 19.9772C14.7467 17.3075 16.2941 15.3143 18.2209 15.3143C19.859 15.3143 20.6501 16.5442 20.6501 18.0189C20.6501 19.6662 19.6013 22.1292 19.0601 24.4116C18.6077 26.3226 20.0184 27.881 21.9032 27.881C25.3157 27.881 27.9389 24.2829 27.9389 19.089C27.9389 14.4918 24.6356 11.2777 19.9189 11.2777C14.4559 11.2777 11.2493 15.3753 11.2493 19.6099C11.2493 21.2601 11.885 23.0296 12.6782 23.9915C12.8351 24.1817 12.8581 24.3482 12.8113 24.5422C12.6656 25.1487 12.3417 26.4528 12.2781 26.7197C12.1944 27.0711 11.9998 27.1457 11.636 26.9764C9.23802 25.8602 7.73876 22.3543 7.73876 19.5383C7.73876 13.4817 12.1393 7.91953 20.4249 7.91953C27.0854 7.91953 32.2613 12.6657 32.2613 19.0085C32.2613 25.6255 28.0892 30.9509 22.2983 30.9509C20.3527 30.9509 18.5237 29.9401 17.8976 28.7462C17.8976 28.7462 16.9349 32.4121 16.7015 33.3104C16.268 34.9781 15.0978 37.0685 14.3152 38.3438C16.1116 38.9 18.0207 39.2 20 39.2C30.6039 39.2 39.2 30.6038 39.2 20.0001C39.2 9.39629 30.6039 0.80014 20 0.80014Z' 
                    fill={fillColor} />
            </svg>
        </BadgeContainer>
    );
});
